import { createStore } from "vuex";
import auth from "./modules/auth";
import courses from "./modules/courses";
import kpis from "./modules/kpis";
import course from "./modules/course";
import regions from "./modules/regions";
import packages from "./modules/packages";
import utilities from "./modules/utilities";
import holes from "./modules/holes";
import drivingRangePins from "./modules/drivingRangePins";
import outlines from "./modules/outlines";
import timezones from "./modules/timezones";
import devices from "./modules/devices";
import devicesFilterOptions from "./modules/devicesFilterOptions";
import toastNotification from "./modules/toastNotification";
import historicalLogs from "./modules/historicalLogs";
import actionLogs from "./modules/actionLogs";
import teesheet from "./modules/teesheet";
import defaultTeetimes from "./modules/defaultTeetimes";
import users from "./modules/users";
import WindtagFilterOptions from "./modules/WindtagDevicesFilterOptions";
import windtagDevices from "./modules/windtagDevices";
import golfWeather from "./modules/golfWeather";

export default createStore({
  modules: {
    auth,
    kpis,
    courses,
    course,
    regions,
    packages,
    utilities,
    holes,
    drivingRangePins,
    outlines,
    timezones,
    devices,
    devicesFilterOptions,
    toastNotification,
    historicalLogs,
    actionLogs,
    teesheet,
    defaultTeetimes,
    users,
    WindtagFilterOptions,
    windtagDevices,
    golfWeather,
  },
});
